import React from "react";
import { Container } from "../../atoms";
export default function DividerSection(param) {
    var className = param.className;
    return /*#__PURE__*/ React.createElement(Container, {
        name: DividerSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: "border-b border-b-fg-base/20"
    }));
}

//# sourceMappingURL=DividerSection.js.map